import { useState, useEffect } from "react"
import * as React from "react"
import { useApp } from "../../AppProvider"
import { Grid, Typography, Button, TextField } from "@mui/material"
import { useSearchParams } from "react-router-dom"
import { changePassword, validateTokenExpiration } from "./services/api"
import { useNavigate } from "react-router"
import { makeStyles } from "@mui/styles"
import { useForm } from "react-hook-form"
import loginImage from "../../assets/login_image.svg"
import logoStock from "./../../assets/spinmovilFullLogo.svg"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import ExpiredLink from "../expiredLink"
import ErrorIcon from "@mui/icons-material/Error"
import fondoLogin from "./../../assets/fondoLogin.png"
import PrimaryButton from "../../components/PrimaryButton"

const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    backgroundColor: "#FFFFFF",
    fontFamily: "Ubuntu, sans-serif",
  },
  loginIcon: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    background: "rgba(6 153 226)",
  },
  baseFrame: {
    height: "auto",
    width: "36.5%",
    ["@media (max-width: 1300px)"]: {
      width: "30%",
    },
    ["@media (max-width: 1200px)"]: {
      width: "25%",
    },
  },
  phoneImage: {
    position: "absolute",
    height: "80%",
    marginRight: "8%",
  },
  titleText: {
    color: "#F5F5F5",
    margin: 0,
    fontWeight: "400",
    fontFamily: "Ubuntu, sans-serif",
    fontSize: "35px",
    "& b": {
      color: "#1BC3DD",
      fontWeight: "700",
    },
    "& strong": {
      color: "#F5F5F5",
      margin: 0,
      fontWeight: "700",
      fontFamily: "Ubuntu, sans-serif",
      fontSize: "35px",
    },
    ["@media (max-width: 1370px)"]: {
      fontSize: 30,
    },
  },
  titleImage: {
    width: "35vw",
    position: "absolute",
    bottom: "10vh",
    right: "45.9%",
  },
  formInput: {
    "& .MuiInputBase-root": {
      height: "53px !important",
    },
    "& .MuiInputLabel-root": {
      color: "rgba(0, 0, 0, 0.40)",
      fontFamily: "Ubuntu",
      fontSize: "14px !Important",
      fontWeight: "400",
    },
    "& .Mui-focused": {
      color: "#000000 !important",
    },
    "& .Mui-error": {
      color: "#d32f2f !important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderRadius: "8px",
        borderColor: "#4E5589",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4E5589",
      },
      "&.Mui-error fieldset": {
        borderColor: "#d32f2f",
      },
    },
  },
  esmsLogo: {
    width: "320px",
    marginBottom: "20px !important",
    ["@media (max-width: 1300px)"]: {
      width: "15vw",
    },
  },
  acceptButton: {
    borderColor: "#4E5589 !important",
    textTransform: "none !important",
    borderWidth: "2px !important",
    borderRadius: "8px !important",
    color: "#4E5589 !important",
    height: "53px !important",
    "&:hover": {
      /* background: " linear-gradient( #008C0D 33.74%, #00BF19 96.06%);", */
      background: "#4E5589 !important",
      boxShadow:
        "0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1) !important",
      color: "white !important",
    },
  },
  formFrame: {
    borderRadius: "8px",
    backgroundColor: "#F7F7F7",
    height: "747px",
    width: "528.56px",
    display: "flex",
    padding: "154px 0px 0px 0px",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
    ["@media (max-height: 1000px)"]: {
      height: "calc(95vh - 154px)",
    },
    ["@media (min-height: 1001px)"]: {
      height: "747px",
    },
  },
}))

const ChangePassword = () => {
  const navigate = useNavigate()
  let [searchParams] = useSearchParams()
  const classes = useStyles()
  const { showNotification } = useApp()
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
  } = useForm()
  const { password: passwordError, secondPassword: secondPasswordError } =
    errors
  const [showPassword, setShowPassword] = useState(false)
  const [showRepeatPassword, setShowRepeatPassword] = useState(false)
  const [open, setOpen] = useState(false)
  const [expired, setExpired] = useState(false)

  const message =
    "El enlace que has recibido por correo electrónico ha caducado. Para recuperar tu contraseña, haz clic en el siguiente botón."

  useEffect(async () => {
    const token = searchParams.get("token")
    try {
      const response = await validateTokenExpiration(token)
      if (!response.data.isValid) {
        setOpen(true)
      } else {
        setExpired(true)
      }
    } catch (error) {
      setOpen(true)
    }
  }, [])

  const handleExpiredLinkButton = () => {
    navigate("/recover-password")
  }

  const onSubmit = async ({ password, secondPassword }) => {
    try {
      await changePassword(password, searchParams.get("token"))
      showNotification("Nueva contraseña registrada exitosamente", "success")
      setTimeout(() => {
        navigate("/login")
      }, 5000)
    } catch (error) {
      showNotification(
        "Lo sentimos, se ha producido un error inesperado al configurar la nueva contraseña",
        "error"
      )
    }
  }

  return (
    <React.Fragment>
      {expired == true ? (
        <Grid
          container
          className={classes.recoverRoot}
          alignItems="center"
          justifyContent="center"
        >
          <Grid
            item
            xs={5.4}
            sm={5.4}
            md={5.4}
            sx={{
              height: "100vh",
              display: "flex",
              backgroundImage: `url(${fondoLogin})`,
              backgroundSize: "100% 100%",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div style={{ width: "100%", padding: "33.7% 28% 0px 15%" }}>
              <p className={classes.titleText}>
                ¡<strong>Conecta</strong> con tus clientes! <br />
                <br />
                <b>Envía</b> tus campañas{" "}
                <strong>
                  por <br /> SMS{" "}
                </strong>{" "}
                de forma{" "}
                <b>
                  {" "}
                  rápida y <br />
                  segura
                </b>
                .
              </p>
            </div>
          </Grid>
          <Grid
            item
            className={classes.baseFrame}
            xs={6.6}
            sm={6.6}
            md={6.6}
            container
            direction="column"
            alignItems="center"
          >
            <div className={classes.formFrame}>
              <Grid
                item
                container
                className={classes.esmsLogo}
                justifyContent="center"
              >
                <img
                  alt="andromeda"
                  src={logoStock}
                  style={{ height: "100%" }}
                />
              </Grid>

              <Grid
                item
                style={{
                  textAlign: "center",
                  marginBottom: "25px",
                  letterSpacing: "0.15px",
                  fontFamily: "Ubuntu, sans-serif",
                  fontSize: "24px",
                  lineHeight: "24px",
                }}
              >
                <p>Recuperar contraseña</p>
              </Grid>
              <Grid item container direction="column" alignItems="center">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  style={{ width: "100%" }}
                >
                  <Grid
                    item
                    container
                    direction="column"
                    spacing={2}
                    alignItems="center"
                  >
                    <Grid
                      item
                      sx={{
                        background: "#e8e8e8",
                        width: "329px",
                        height: "72px",
                        marginLeft: "16px",
                        marginBottom: "8px",
                        padding: "5px 15px 5px 15px !important",
                        borderRadius: "8px",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Ubuntu, sans-serif",
                          fontSize: "14px",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          color: "#000",
                          display: "flex",
                          fontWeight: "500",
                          alignItems: "center",
                        }}
                      >
                        <ErrorIcon
                          sx={{
                            color: "#1BC3DD",
                            fontSize: "14px",
                            marginRight: "3px",
                            fontWeight: "500",
                          }}
                        ></ErrorIcon>
                        Protege tu cuenta con:
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: "Ubuntu, sans-serif",
                          fontSize: "12px",
                          lineHeight: "20px",
                          fontWeight: "400",
                          letterSpacing: "0.15px",
                          color: "#696A74",
                        }}
                      >
                        Mínimo 6 dígitos. Mayúsculas. Minúsculas <br /> Números
                        y símbolos.
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="row"
                      justifyContent="center"
                      marginBottom="17px"
                    >
                      <Grid item container justifyContent="center">
                        <TextField
                          id="password"
                          label="Nueva Contraseña"
                          type={showPassword === false ? "password" : "text"}
                          className={classes.formInput}
                          variant="outlined"
                          sx={{
                            width: "328px",
                            height: "50px",
                          }}
                          InputLabelProps={{
                            sx: {
                              fontFamily: "Ubuntu",
                              fontSize: "14px",
                            },
                          }}
                          helperText={passwordError?.message}
                          error={passwordError !== undefined}
                          InputProps={{
                            endAdornment: (
                              <Button
                                sx={{ display: "flex", justifyContent: "end" }}
                                onClick={() => {
                                  setShowPassword(!showPassword)
                                }}
                              >
                                {showPassword === true ? (
                                  <VisibilityOff
                                    style={{ color: "rgba(0, 0, 0, 0.6)" }}
                                  />
                                ) : (
                                  <Visibility
                                    style={{ color: "rgba(0, 0, 0, 0.6)" }}
                                  />
                                )}
                              </Button>
                            ),
                          }}
                          {...register("password", {
                            required: {
                              value: true,
                              message: "Campo obligatorio",
                            },
                            maxLength: {
                              value: 15,
                              message:
                                "La contraseña supera el límite de caracteres permitidos",
                            },
                            minLength: {
                              value: 6,
                              message:
                                "La contraseña no cumple con el mínimo de caracteres",
                            },
                          })}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="row"
                      justifyContent="center"
                      marginBottom="37px"
                    >
                      <Grid item container justifyContent="center">
                        <TextField
                          id="s_password"
                          label="Confirmar contraseña"
                          type={
                            showRepeatPassword === false ? "password" : "text"
                          }
                          className={classes.formInput}
                          variant="outlined"
                          sx={{
                            width: "328px",
                            height: "50px",
                          }}
                          InputLabelProps={{
                            sx: {
                              fontFamily: "Ubuntu",
                              fontSize: "14px",
                            },
                          }}
                          helperText={secondPasswordError?.message}
                          error={secondPasswordError !== undefined}
                          InputProps={{
                            endAdornment: (
                              <Button
                                sx={{ display: "flex", justifyContent: "end" }}
                                onClick={() => {
                                  setShowRepeatPassword(!showRepeatPassword)
                                }}
                              >
                                {showRepeatPassword === true ? (
                                  <VisibilityOff
                                    style={{ color: "rgba(0, 0, 0, 0.6)" }}
                                  />
                                ) : (
                                  <Visibility
                                    style={{ color: "rgba(0, 0, 0, 0.6)" }}
                                  />
                                )}
                              </Button>
                            ),
                          }}
                          {...register("secondPassword", {
                            required: {
                              value: true,
                              message: "Campo obligatorio",
                            },
                            validate: {
                              passwordsMatch: (value) =>
                                value === getValues("password") ||
                                "Las contraseñas no coinciden",
                            },
                            maxLength: {
                              value: 15,
                              message:
                                "La contraseña supera el límite de caracteres permitidos",
                            },
                            minLength: {
                              value: 6,
                              message:
                                "La contraseña no cumple con el mínimo de caracteres",
                            },
                          })}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="row"
                      justifyContent="center"
                    >
                      <Grid item container justifyContent="center">
                        <PrimaryButton
                          width="328px"
                          height="53px"
                          action={() => {}}
                          text="Guardar"
                          fontSize="20"
                          type="submit"
                        ></PrimaryButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </div>
          </Grid>
        </Grid>
      ) : (
        <React.Fragment></React.Fragment>
      )}
      <ExpiredLink
        open={open}
        setOpen={setOpen}
        message={message}
        button={handleExpiredLinkButton}
      />
    </React.Fragment>
  )
}

export default ChangePassword
